import React, { Component, Fragment } from "react";
import AmortizingSchedule from "./AmortizingSchedule";
import AmortizingSummary from "./AmortizingSummary";
import { segmentEventTracker } from "../../../utils/SegmentEventTracker";
import { TrackEventName } from "../../shared/constants/SegmentEvents";

class AmortizingDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      previewToggle: false,
    };
    this.togglePreview = this.togglePreview.bind(this);
  }

  togglePreview() {
    this.setState({ previewToggle: !this.state.previewToggle },() => {
      segmentEventTracker.trackEvent(
        TrackEventName.LOAN_OFFER_BREAKDOWN_CLICKED,
        { action: this.state.breakdownView ? 'View' : 'Hide' });
    })
  }

  renderBreakdownToggle() {
    return (
      <button
        className="ds-btn -secondary --full"
        onClick={this.togglePreview}
        data-testid="breakdown-toggle"
      >

        {this.state.previewToggle ? "Hide" : "View"} payment schedule & fees
        <i className="materialIcon -secondary">
          {this.state.previewToggle
            ? "keyboard_arrow_up"
            : "keyboard_arrow_down"}
        </i>
      </button>
    );
  }

  render() {
    return (
      <Fragment>
        {this.state.previewToggle && (
          <AmortizingSchedule
            loanStartDate={this.props.start_date}
            paymentSchedules={this.props.payment_schedules}
          />
        )}
        {this.state.previewToggle && (
          <AmortizingSummary
            disbursedAmount={this.props.disbursed_amount}
            interestAmount={this.props.interest_amount}
            repaymentAmount={this.props.repayment_amount}
            serviceFee={this.props.service_fee}
            serviceFeeAmount={this.props.service_fee_amount}
            totalRepaymentAmount={this.props.total_repayment_amount}
            totalInterestAmount={this.props.total_interest_amount}
            equivalentAor={this.props.equivalent_aor}
            isForPayment={this.props.isForPayment}
          />
        )}

        {this.renderBreakdownToggle()}
      </Fragment>
    );
  }
}
export default AmortizingDetails;



// WEBPACK FOOTER //
// ./src/features/loans/components/AmortizingDetails.js